export class Contact {
  showInfoOnMap = true;
  title = 'Contact Us';
  subtitle = '';
  routeEmailToContact = true;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/contact.ts